// extracted by mini-css-extract-plugin
export default {"main":"ProjectContent_main__aGSUt","mainBackground":"ProjectContent_mainBackground__4vI71","mobile":"ProjectContent_mobile__zqO-R","title":"ProjectContent_title__HkiuZ"};